<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <a [routerLink]="'/translation/bot-rules'">Bot rules</a>
    </li>
    <li class="breadcrumb-item" aria-current="page">
      @if (isCreate()) {
        <span class="fs-5 fw-bold mb-0">Add rule</span>
      }
      @if (!isCreate()) {
        <span class="fs-5 fw-bold mb-0">Edit rule</span>
      }
    </li>
  </ol>
</nav>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <div
        class="bg-tertiary p-2 border-start border-warning border-5 d-flex justify-content-between align-items-center mb-3">
        <h2 class="fw-bold fs-6 mb-0">Informations</h2>
        <i class="bi bi-person-bounding-box text-primary me-2"></i>
      </div>

      <div class="row g-3 mb-3">
        <div class="col">
          <label for="name" class="form-label">Name</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-building"></i></span>
            <input type="text" class="form-control" id="name" formControlName="name">
          </div>
        </div>
        <div class="col">
          <label for="rule" class="form-label">Rule</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-building"></i></span>
            <input type="text" class="form-control" id="rule" formControlName="rule">
          </div>
        </div>
      </div>

      <div class="row g-3 mb-3">
        <div class="col">
          <label for="allowed" class="form-label">Access</label>
          <app-input-switch formControlName="allowed" id="allowed" [onLabel]="'Allowed'"
          [offLabel]="'Denied'"></app-input-switch>
        </div>
      </div>

      <div class="col-12 text-end mt-5">
        <button type="submit" class="btn btn-primary fw-bold" [disabled]="!canUpdate()">
          @if (isCreate()) {
            <span>Create</span>
          }
          @if (!isCreate()) {
            <span>Update</span>
          }
        </button>
      </div>
    </form>
  </div>
</div>
